import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AreasTable = ({ areas, governorate, language, onEdit, onDelete }) => {
  const labels = {
    areaName: { en: 'Area Name', ar: 'اسم المنطقة' },
    actions: { en: 'Actions', ar: 'الإجراءات' },
    noAreas: { en: 'No areas in this governorate', ar: 'لا توجد مناطق في هذه المحافظة' }
  };

  if (!areas || areas?.length === 0) {
    return (
      <div className="text-center py-8">
        <Icon name="MapPin" size={32} className="mx-auto text-muted-foreground mb-2" />
        <p className="text-sm text-text-secondary">{labels?.noAreas?.[language]}</p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/30 border-b border-border">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">
                {labels?.areaName?.[language]}
              </th>
              <th className="px-4 py-3 text-center text-sm font-semibold text-foreground">
                {labels?.actions?.[language]}
              </th>
            </tr>
          </thead>
          <tbody>
            {areas?.map((area) => (
              <tr key={area?.id} className="border-b border-border hover:bg-muted/30 transition-smooth">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <Icon name="MapPin" size={16} className="text-primary" />
                    <span className="text-sm font-medium text-foreground">{area?.name}</span>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-center gap-2">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onEdit(area, governorate)}
                      className="h-8 w-8"
                    >
                      <Icon name="Edit" size={16} />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onDelete(area, governorate)}
                      className="h-8 w-8 text-error hover:text-error"
                    >
                      <Icon name="Trash2" size={16} />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AreasTable;